import { render, staticRenderFns } from "./multilingual.vue?vue&type=template&id=817b3f8e&"
import script from "./multilingual.vue?vue&type=script&lang=js&"
export * from "./multilingual.vue?vue&type=script&lang=js&"
import style0 from "./multilingual.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports